const CLEAR_COMMENT_LIST = 'fulcrum/containers/Project/GLTCommentSection/CLEAR_COMMENT_LIST'
const UPDATE_COMMENT_LIST = 'fulcrum/containers/Project/GLTCommentSection/UPDATE_COMMENT_LIST'
const POST_COMMENT = 'fulcrum/containers/Project/GLTCommentSection/POST_COMMENT'
const POST_COMMENT_START = 'fulcrum/containers/Project/GLTCommentSection/POST_COMMENT_START'
const POST_COMMENT_SUCCESS = 'fulcrum/containers/Project/GLTCommentSection/POST_COMMENT_SUCCESS'
const POST_COMMENT_ERROR = 'fulcrum/containers/Project/GLTCommentSection/POST_COMMENT_ERROR'
const FETCH_COMMENTS = 'fulcrum/containers/Project/GLTCommentSection/FETCH_COMMENTS'
const FETCH_COMMENTS_START = 'fulcrum/containers/Project/GLTCommentSection/FETCH_COMMENTS_START'
const FETCH_COMMENTS_SUCCESS = 'fulcrum/containers/Project/GLTCommentSection/FETCH_COMMENTS_SUCCESS'
const FETCH_COMMENTS_ERROR = 'fulcrum/containers/Project/GLTCommentSection/FETCH_COMMENTS_ERROR'

export {
  CLEAR_COMMENT_LIST,
  UPDATE_COMMENT_LIST,
  POST_COMMENT,
  POST_COMMENT_START,
  POST_COMMENT_SUCCESS,
  POST_COMMENT_ERROR,
  FETCH_COMMENTS,
  FETCH_COMMENTS_START,
  FETCH_COMMENTS_SUCCESS,
  FETCH_COMMENTS_ERROR,
}
